module.exports = __webpack_public_path__ + "img/Kew-Gardens-Grow.fddb65c3.jpg";